import { IOption } from 'src/app/components/shared/form/components/form-select/form-select.model';
import { CvisSwap } from 'src/app/SCI/core/models/cvis-swap.model';
import { EdiSwap } from 'src/app/SCI/core/models/edi-swap.model';

export type SwapData = {
  isEdi: boolean;
  edit: boolean;
  val: EdiSwap | CvisSwap;
};

export const CONSTANTS = {
  HEADER_ADD: $localize`Add Record`,
  HEADER_EDIT: $localize`Edit Record`,
  BUTTON_TEXT: $localize`Save`,
  BODY: {
    ID: $localize`ID`,
    NAME: $localize`Name`,
    ACTIVE: $localize`Active`,
    EFFECTIVE_DATE: $localize`Effective Date`,
    EXPIRY_DATE: $localize`Expiry Date`,
    AVAILABILITY: $localize`Availability?`,
    ORIG_CODE: $localize`Orig Code`,
    ORIG_SORT: $localize`Orig Sort`,
    DEST_SLIC: $localize`Dest SLIC`,
    DEST_SORT: $localize`Dest Sort`,
    SWAP_SLIC: $localize`Swap SLIC`,
    SWAP_SORT: $localize`Swap Sort`,
    SVC: $localize`SVC`,
    SWAP_SVC: $localize`Swap SVC`,
    SWAP_LOC_ROLES: $localize`Swap Loc Roles`,
  },
};

export const AVAILABILITIES = [
  { control: 'mon', label: $localize`Mo` },
  { control: 'tue', label: $localize`Tu` },
  { control: 'wed', label: $localize`We` },
  { control: 'thu', label: $localize`Th` },
  { control: 'fri', label: $localize`Fr` },
  { control: 'sat', label: $localize`Sa` },
  { control: 'sun', label: $localize`Su` },
];

export const LCDS = [
  { control: 'monLcd', label: $localize`Mo LCD` },
  { control: 'tueLcd', label: $localize`Tu LCD` },
  { control: 'wedLcd', label: $localize`We LCD` },
  { control: 'thuLcd', label: $localize`Th LCD` },
  { control: 'friLcd', label: $localize`Fr LCD` },
  { control: 'satLcd', label: $localize`Sa LCD` },
  { control: 'sunLcd', label: $localize`Su LCD` },
];

export const DESTINATION_SORT_OPTIONS: IOption[] = [
  { label: 'S', value: '01' },
  { label: 'M', value: '02' },
  { label: 'D', value: '03' },
  { label: 'T', value: '04' },
  { label: 'N', value: '05' },
  { label: 'P', value: '06' },
  { label: 'L', value: '07' },
  { label: 'A', value: '08' },
];

export const SERVICE_LEVEL_OPTIONS: IOption[] = [
  { label: '1DA', value: '001' },
  { label: '2DA', value: '002' },
  { label: '3DS', value: '012' },
  { label: 'EAM', value: '014' },
  { label: 'GND', value: '004' },
];

export const SWAP_LOC_OPTIONS: IOption[] = [
  { label: 'None', value: 'none' },
  { label: 'Location', value: '12' },
  { label: 'Agent', value: '06' },
];

export const ACTIVE_DROPDOWN_OPTIONS: IOption[] = [
  { label: 'Y', value: true },
  { label: 'N', value: false },
];
